import { render, staticRenderFns } from "./SynatecOrder.vue?vue&type=template&id=3a1a6df3&"
import script from "./SynatecOrder.vue?vue&type=script&lang=js&"
export * from "./SynatecOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports